<template>
  <base-section id="theme-features">
    <v-container>
      <v-row>
        <v-col v-for="(feature, i) in features" :key="i" cols="12" md="4">
          <base-avatar-card v-bind="feature" align="left" horizontal />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionThemeFeatures",

  data: () => ({
    features: [
      {
        color: "blue darken-2",
        dark: true,
        title: "Data as API",
        icon: "mdi-api",
        text: "Secure data infrastructure providing secure and cost efficient access to reliable and high-quality data.",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Operation Automation",
        icon: "mdi-account-question",
        text: "Digitize your ship operation - Explore maritime software",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "help desk automation",
        icon: "mdi-desktop-classic",
        text: "Set-up your helpdesk for automatic actions when defined events take place. Workflow. Ticket Assignment.",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Supplier Management ",
        icon: "mdi-account-clock",
        text: "Discover How Automation can Improve Performance Across the Supply Chain",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "vessel Scheduling System",
        icon: "mdi-clipboard-list",
        text: "Vessel Scheduling System is an integrated system caters for coastal voyages with coastal schedules. Receiving the right schedule information at right time.",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "maritime business intelligent (BI) services ",
        icon: "mdi-account-wrench",
        text: "Business intelligence (BI) services help enable structured data-driven decision-making across the company.",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Crew management software",
        icon: "mdi-laptop",
        text: "The Solution to the Hassles of crew scheduling ",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Cyber security solutions ",
        icon: "mdi-shield-lock",
        text: "Stay Safe & Protect Your Business & Customer Data. Explore our Cyber Security Solutions.",
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Maritime Cyber Security Awareness.",
        icon: "mdi-account-lock",
        text: "Our e-learning course can be applied to cyber security within the maritime and offshore industries. ",
      },
    ],
  }),
};
</script>
